import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  standalone: false,
  selector: 'fl-qrcode',
  template: `
    <qrcode
      [alt]="alt"
      [cssClass]="fullWidth ? 'FullWidth' : undefined"
      [elementType]="'img'"
      [margin]="imageMargin"
      [qrdata]="data"
      [width]="width"
    >
    </qrcode>
  `,
  styleUrls: ['./qr-code.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class QrCodeComponent {
  @Input() alt: string;
  @Input() data: string;
  @Input() width: number;
  /** Margin on the generated QR code image */
  @Input() imageMargin = 4;
  @Input() fullWidth = false;
}
